import { useSelector, useDispatch } from 'react-redux';
import { loadAllDocs, LoadData } from '../redux/actions/sharedViews';
import { actionTypes } from "../redux/contants/actionTypes";
import { getAllDocs } from '../redux/actions/sharedViews';
import { useCallback } from 'react';


export const useSharedViews = () => {
    const dispatch = useDispatch();
    const {
        listAllDocs,
        isLoading,
        listDeatils,
        listConfiguration,
        columsTableDeatails,
        isLoadingDetails,
        rowsChecked,
        filters,
        pagination,
        counter,
        id_user_action,
        id_company,
        select_company
    } = useSelector(state => state.sharedViews);

    const handleRowsChecked = (obj) => {
        dispatch(LoadData(actionTypes.rowsChecked, obj));
    };

    const updateFilters = (newFilters) => {
        dispatch(LoadData(actionTypes.filterAndPagination, { filters: { ...filters, ...newFilters }, pagination }));
    };

    const updatePagination = (newPagination) => {
        dispatch(LoadData(actionTypes.filterAndPagination, { filters, pagination: { ...pagination, ...newPagination } }));
    };

    const resetInitState = useCallback(() => {
        dispatch(loadAllDocs([]));
        dispatch(LoadData(actionTypes.resetFilterAndPagination, {}));
        dispatch(LoadData(actionTypes.counter, 0));
    }, [dispatch]);

    return [{
        updateFilters,
        updatePagination,
        handleRowsChecked,
        getAllDocs,
        resetInitState,
        listAllDocs,
        isLoading,
        listDeatils,
        listConfiguration,
        columsTableDeatails,
        isLoadingDetails,
        rowsChecked,
        filters,
        pagination,
        counter,
        id_user_action,
        id_company,
        select_company
    }];
};